// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { memo } from 'react';
import { Navigate, RouteObject, useRoutes } from 'react-router-dom';
import RenderGrout from '../screens/RenderGrout/RenderGrout.screen';
import SelectTile from '../screens/Visualizer/Tile/SelectTile/SelectTile.screen';
import ConfigureTile from '../screens/Visualizer/Tile/ConfigureTile/ConfigureTile.screen';
import Visualizer from '../screens/Visualizer/Visualizer';
import CapturePhoto from '../screens/Visualizer/Tile/CaptureTilePhoto/CaptureTilePhoto.screen';
import EditTile from '../screens/Visualizer/Tile/EditTile/EditTile.screen';
import SelectGroutColors from '../screens/Visualizer/Tile/SelectGroutColors/SelectGroutColors';
import ViewRoom from '../screens/Visualizer/RoomScene/ViewRoom/ViewRoom.screen';
import SelectRoom from '../screens/Visualizer/RoomScene/SelectRoom/SelectRoom.screen';

export type RouteProperties = {
  withoutHeader?: boolean;
  withoutFooter?: boolean;
};

export const MainRoutes: RouteObject[] & RouteProperties[] = [
  {
    path: 'visualizer',
    element: <Visualizer />,
  },
  {
    path: 'visualizer/select-tile',
    element: <SelectTile />,
  },
  {
    path: 'visualizer/capture-tile',
    element: <CapturePhoto />,
    withoutHeader: true,
    withoutFooter: true,
  },
  {
    path: 'visualizer/edit-tile',
    element: <EditTile />,
  },
  {
    path: 'visualizer/configure-tile',
    element: <ConfigureTile />,
  },
  {
    path: 'visualizer/configure-tile/grout-colors',
    element: <SelectGroutColors />,
  },
  {
    path: 'grout',
    element: <RenderGrout />,
  },
  {
    path: 'visualizer/room/select',
    element: <SelectRoom />,
    // children: [...ConfigureTileStep3],
  },
  {
    path: 'visualizer/:room/view',
    element: <ViewRoom />,
  },
];

const Route = () =>
  useRoutes([...MainRoutes, { path: '*', element: <Navigate to="/visualizer" replace /> }]);

export default memo(Route);
